import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";



class PaymentNoticeView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;
		
		this.dataobject = null;

		this.quote = null;
		this.order = null;
		this.invoice = null;
		this.paymentnotice = null;
		
		let title = '';
		let description = '';
		let amount = 0;
		let currency = {symbol: ''};
		let currentcard = null;

		
		this.state = {
				title,
				description,
				amount,
				currency,
				registration_text: 'loading...',
				message_text: 'loading...',
				sharelinkmessage: 'loading...',
				sharelink: 'loading...',
				currentcard,
				isQuoteOwner: false,
				isOrderOwner: false,
				isInvoiceOwner: false,
				isPaymentNoticeOwner: false,
				payerraddress: '',
				payername: '',
				payeremail: ''
		}
	}

	
	// post render commit phase
	componentDidMount() {
		console.log('PaymentNoticeView.componentDidMount called');
		let mvcmodule = this.getMvcModuleObject();
		let sessionuuid = this.props.rootsessionuuid;
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let registration_text = mvcmyquote.t('This paymentnotice has been registered.');
		
		let message_text = mvcmyquote.t('Payer details:');
	
		let sharelinkmessage = mvcmyquote.t('Send this link to the vendor to serve as payment notice:');
		
		
		this.setState({registration_text, message_text, sharelinkmessage});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;
		
		if (app_nav_target && (app_nav_target.route == 'paymentnotice') && (app_nav_target.reached == false)) {
			var params = app_nav_target.params;
			var dataobj = params.dataobject;

			if (dataobj && (dataobj.type === 'paymentnotice') && (dataobj.treated !== true)) {
				this.dataobject = dataobj;

				let paymentnotice = dataobj;
				this.paymentnotice = dataobj;

				let txhash = params.txhash;
	
				let amount = paymentnotice.amount;
				let currencyuuid = paymentnotice.currencyuuid;

				// time
				let registration_text = mvcmyquote.t('This paymentnotice has been registered on');

				registration_text += ' ' + mvcmodule.formatDate(paymentnotice.blocktime, 'YYYY-mm-dd HH:MM:SS') + '.';


				// payer details
				let payername_encrypted = paymentnotice.ownername;
				let payeremail_encrypted = paymentnotice.owneremail;
				let paymenturl_encrypted = paymentnotice.paymenturl;
				
				let payeraddress = paymentnotice.owner;
				let payername = mvcmodule.fitString(payername_encrypted, 12);
				let payeremail = mvcmodule.fitString(payeremail_encrypted, 12);
				let paymenturl = paymenturl_encrypted;
	
				let currency = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {
					console.log('error in PaymentNoticeView.checkNavigationState: ' + err);
				});
	
				var sharelink =  await this.app.getShareLink(txhash, currency.uuid);

				// original invoice
				let invoice = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, paymentnotice.invoice);
				this.invoice = invoice;

				// original order
				let order = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, invoice.order);
				this.order = order;

				// original quote
				let quote = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, order.quote);
				this.quote = quote;

				let title = quote.title;
				let description = quote.description;

				// look if a wallet is open
				let currentcard = null;
				let isQuoteOwner = false;
				let isOrderOwner = false;
				let isInvoiceOwner = false;
				let isPaymentNoticeOwner = false;

				let unlocked = await this.app.checkWalletUnlocked()
				.catch(err => {
				});

				if (unlocked) {
					let currentwallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
					
					// is it the quote owner and/or the order own
					currentcard = await this.app.openCurrencyCard(currencyuuid)
					.catch(err => {
						console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
					});

					if (currentcard) {
						let decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, paymentnotice.owner);
						let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, currentcard.uuid, currencyuuid);

						if (decryptcard) {
							isPaymentNoticeOwner = true;

							payername = mvcmyquote.t('You');
							payeremail = currentwallet.owneremail;					
						}

						decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, invoice.owner);
						if (decryptcard) {
							isInvoiceOwner = true;

							// we decrypt the payer's details
							let payer_rsa_publickey = paymentnotice.owner_rsa_publickey;
	
							let payername_plain = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, payer_rsa_publickey, payername_encrypted)
							.catch(err => {
								console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
							});
	
							let payeremail_plain = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, payer_rsa_publickey, payeremail_encrypted)
							.catch(err => {
								console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
							});
							
							payername = (payername_plain ? payername_plain : payername);
							payeremail = (payeremail_plain ? payeremail_plain  : payeremail);
							
							// and payment url
							let paymenturl_plain = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, payer_rsa_publickey, paymenturl_encrypted)
							.catch(err => {
								console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
							});
							
							paymenturl = (paymenturl_plain ? paymenturl_plain : paymenturl);
	
						}

						decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, order.owner);
						if (decryptcard) {
							isOrderOwner = true;
						}

						decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, quote.owner);
						if (decryptcard) {
							isQuoteOwner = true;
						}
					}
				}
	
				this.setState({title, description, amount, currency, currentcard, registration_text, isQuoteOwner, isOrderOwner, isInvoiceOwner, 
					isPaymentNoticeOwner, sharelink, paymenturl, payeraddress, payername, payeremail});

				dataobj.viewed = true;
			}

			// mark target as reached
			app_nav_target.reached = true;		
		}
	}
	
	
	// user actions
	async onSubmit() {
		console.log('onSubmit pressed!');
		
		const {paymenturl} = this.state;

		// trim paymenturl
		let _paymenturl = 'error';

		let startpos = 0;
		let protocolendpos = paymenturl.indexOf('://');
		
		if (protocolendpos) {
			let protocolstartpos = protocolendpos;
			// find protocol (http, https or applink)
			while (protocolstartpos && paymenturl.charAt(protocolstartpos) != ' ') {
				protocolstartpos--;
			}

			startpos = protocolstartpos;
		}

		_paymenturl = paymenturl.slice(startpos);
		_paymenturl = _paymenturl.trim();
		
		// create a textarea on the fly, then remove it to
		// be able to copy to clipboard
		var textArea = document.createElement("textarea");
		textArea.value = _paymenturl;

		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand("Copy");
		textArea.remove();

		this.app.alert("Payment url has been copied to clipboard");

		
		return true;
	}

	async onShareLinkClick() {
		const {sharelink} = this.state;
		
		// create a textarea on the fly, then remove it to
		// be able to copy to clipboard
		var textArea = document.createElement("textarea");
		textArea.value = sharelink;

		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand("Copy");
		textArea.remove();

		this.app.alert("Share link has been copied to clipboard");
	}

	
	// rendering
	renderPaymentNoticeView() {
		let { title, description, amount, currency, registration_text, message_text, sharelinkmessage, sharelink, 
			isQuoteOwner, isOrderOwner, isInvoiceOwner, isPaymentNoticeOwner, paymenturl, payeraddress, payername, payeremail } = this.state;
		let iswalletlocked = this.props.iswalletlocked;
		
		return (
			<div className="Form">
				<div>
					<FormGroup controlId="title">
					<FormLabel>Quote Title</FormLabel>
					<FormControl
						disabled
						autoFocus
						type="text"
						value={title}
						onChange={e => this.setState({title: e.target.value})}
					/>
					</FormGroup>

					<FormGroup controlId="paymenturl">
					<FormLabel>Payment url {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
					<FormControl 
						as="textarea" 
						rows="5" 
						autoFocus
						type="text"
						value={paymenturl}
						onChange={e => this.setState({paymenturl: e.target.value})}
					/>
					</FormGroup>

					<FormGroup className="Proposal" controlId="proposal">
					<span className="ProposalCol">
					<FormLabel>Amount</FormLabel>
					<FormControl 
						disabled
						autoFocus
						type="text"
						value={amount}
						onChange={e => this.setState({amount: e.target.value})}
					/>
					</span>
					<span className="ProposalCol">
					<FormLabel>Currency</FormLabel>
					<InputGroup>
						<FormControl 
							disabled
							autoFocus
							type="text"
							value={currency.symbol}
							onChange={e => this.onChangeCurrency(e)}
						/>
					</InputGroup>
					</span>
					</FormGroup>

					{(isInvoiceOwner ?
					<Button onClick={this.onSubmit.bind(this)} type="submit">
						Copy Payment Url
					</Button> :
					(iswalletlocked ? <div className="Separator"><span>you are not logged in</span></div> : <hr></hr>)
					)}

					<div className="TextBox">
					{registration_text}
					</div>
					
					<div className="TextBox">
					<div>{sharelinkmessage}</div>
						<div className="ShareBlock">
						<span className="ShareLink" onClick={this.onShareLinkClick.bind(this)}>{sharelink}</span>
						<span className="ShareIcon" onClick={this.onShareLinkClick.bind(this)}><FontAwesomeIcon icon={faCopy} /></span>
						</div>
					</div>

					<div className="TextBox">
					{message_text}
					</div>

					<div className="TextBox">
					<div><span>Payer Name: </span><span>{payername}</span></div>
					<div><span>Payer Email: </span><span>{payeremail}</span></div>
					</div>


				</div>

			</div>
		  );
	}

	render() {
		return (
			<div className="Container">
				<div className="Title">Payment Notice View</div>
				{ this.renderPaymentNoticeView()}
			</div>
		  );
	}
	
}


// propTypes validation
PaymentNoticeView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
	iswalletlocked: PropTypes.bool,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
		iswalletlocked: state.wallets.islocked,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {PaymentNoticeView};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentNoticeView);

